import { GroupDividerSize } from "@components/inputs/select/Select.types";
import { IToolbarItem } from "@components/toolbar/Toolbar.types";
import { LanguageCode } from "@odata/GeneratedEnums";
import i18next from "i18next";

import { RequireKeys } from "../../global.types";
import { EXPORT_GROUP_ID, MASS_EXPORT_GROUP_ID } from "./TableToolbar";

export enum TableButtonsAction {
    Add = "Add",
    CSVExport = "CSVExport",
    ExpandCollapseAll = "ExpandCollapseAll",
    FullscreenOpen = "FullscreenOpen",
    FullscreenClose = "FullscreenClose",
    Lock = "Lock",
    MassEdit = "MassEdit",
    PdfExport = "PdfExport",
    PdfExportReportFull = "PdfExportReportFull",
    PdfExportReportShort = "PdfExportReportShort",
    Remove = "Remove",
    Sorting = "Sorting",
    Settings = "Settings",
    ToggleDraftView = "ToggleDraftView",
    XLSXExport = "XLSXExport",
    MassExport = "MassExport",
    MassExportEn = "MassExportEn",
}

// order spec
// https://solitea-cz.atlassian.net/wiki/spaces/IRIS/pages/2981068806/Po+ad+ikon+v+toolbaru+nad+tabulkami
export enum TableActionOrder {
    Add = 10,
    Remove = 20,
    // every special action should be added after Remove
    ExpandCollapseAll = 30,
    Fullscreen = 40,
    Lock = 50,
    MassEdit = 60,
    Sort = 70,
    Export = 80,
    Settings = 90,
    ToggleDraftView = 100
}

export type TTableToolbarItem = RequireKeys<IToolbarItem, "order">;

export type TableButtonsActionType = TableButtonsAction | string;
export const exportButtonActionGroup = [
    TableButtonsAction.XLSXExport,
    TableButtonsAction.CSVExport,
    TableButtonsAction.PdfExport,
    TableButtonsAction.PdfExportReportShort,
    TableButtonsAction.PdfExportReportFull,
    TableButtonsAction.MassExport,
    TableButtonsAction.MassExportEn,
];

export interface ICustomButtonDefArgs {
    isActive: boolean;
    isDisabled: boolean;
}

export function isMassExportAction(tableAction: string): boolean {
    return tableAction === TableButtonsAction.MassExport || tableAction === TableButtonsAction.MassExportEn;
}

export function overrideMassExportButtonDef(defaultItem: TTableToolbarItem, customMassTitle?: string): TTableToolbarItem {
    if (exportButtonActionGroup.includes(defaultItem.id as TableButtonsAction)) {
        return {
            ...defaultItem,
            itemProps: {
                ...(defaultItem.itemProps ?? {}),
                selectProps: {
                    ...(defaultItem.itemProps?.selectProps ?? {}),
                    groups: [
                        { id: EXPORT_GROUP_ID, title: i18next.t("Components:Table.ExportTableHeader") },
                        {
                            id: MASS_EXPORT_GROUP_ID,
                            title: customMassTitle ?? i18next.t("Components:Table.MassExportPDFHeader"),
                            dividerSize: GroupDividerSize.Small
                        },
                    ]
                }
            }
        };
    }

    return defaultItem;
}

export function getLanguageCodeFromAction(action: string): LanguageCode {
    if (TableButtonsAction.MassExportEn === action) {
        return LanguageCode.English;
    }
    return LanguageCode.Czech;
}